/**
 * Related Calculators Mapping Database
 * Derived from structural groupings in AiCalculatorHub & MultyCalculatorHub.
 * Maps calculators to their logical contextual siblings using exact relational lookups and live URLs.
 *
 * NOTE: exported as a plain ES module default export (not the original UMD
 * module.exports/window.X pattern) so it works cleanly with CRA/webpack's
 * bundler without risking a double-export conflict. The data itself is
 * unchanged from the source provided.
 */

const BASE_URL = "https://munendra5singh.github.io/MultiCalculator";

const relatedCalculators = {
  // --- Finance & Investment Hub ---
  "emi": {
    title: "EMI Calculator",
    category: "Finance",
    url: `${BASE_URL}/emi.html`,
    related: ["loan", "sip", "interest"]
  },
  "loan": {
    title: "Loan Eligibility Calculator",
    category: "Finance",
    url: `${BASE_URL}/loan.html`,
    related: ["emi", "interest"]
  },
  "sip": {
    title: "SIP Calculator",
    category: "Finance",
    url: `${BASE_URL}/sip.html`,
    related: ["interest", "percentage"]
  },
  "interest": {
    title: "Compound Interest Calculator",
    category: "Finance",
    url: `${BASE_URL}/interest.html`,
    related: ["sip", "emi"]
  },
  "gst": {
    title: "GST Calculator",
    category: "Finance",
    url: `${BASE_URL}/gst.html`,
    related: ["discount", "percentage"]
  },
  "discount": {
    title: "Discount Calculator",
    category: "Finance",
    url: `${BASE_URL}/discount.html`,
    related: ["gst", "percentage"]
  },
  "percentage": {
    title: "Percentage Calculator",
    category: "Finance",
    url: `${BASE_URL}/percentage.html`,
    related: ["gst", "discount"]
  },

  // --- Health & Fitness Hub ---
  "bmi": {
    title: "BMI Calculator",
    category: "Health",
    url: `${BASE_URL}/bmi.html`,
    related: ["bmr", "body-fat", "calorie"]
  },
  "bmr": {
    title: "BMR Calculator",
    category: "Health",
    url: `${BASE_URL}/bmr.html`,
    related: ["bmi", "calorie", "body-fat"]
  },
  "body-fat": {
    title: "Body Fat Calculator",
    category: "Health",
    url: `${BASE_URL}/body-fat.html`,
    related: ["bmi", "bmr"]
  },
  "calorie": {
    title: "Calorie Calculator",
    category: "Health",
    url: `${BASE_URL}/calorie.html`,
    related: ["bmr", "bmi"]
  },

  // --- Utility & Tools ---
  "age": {
    title: "Age Calculator",
    category: "Tools",
    url: `${BASE_URL}/age.html`,
    related: ["date-difference", "retirement"]
  },
  "date-difference": {
    title: "Date Difference Calculator",
    category: "Tools",
    url: `${BASE_URL}/date-difference.html`,
    related: ["age"]
  },
  "retirement": {
    title: "Retirement Planner",
    category: "Tools",
    url: `${BASE_URL}/retirement.html`,
    related: ["age", "sip"]
  }
};

export default relatedCalculators;
